import NavBar from '../components/NavBar.jsx';
import Footer from '../components/Footer.jsx';
import ScrollManager from './ScrollManager.jsx';

/** Chrome shared by every public page. */
export default function PublicLayout({ children }) {
  return (
    <div className="overflow-x-hidden">
      <ScrollManager />
      {/*
        Off-screen until focused. The header has a logo, five nav links and two
        buttons in front of the content, and without this a keyboard or screen
        reader user tabs through all of them on every single page.
      */}
      <a
        href="#main"
        className="sr-only rounded-full bg-forest px-5 py-3 font-bold text-white focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-100"
      >
        Skip to content
      </a>

      <NavBar />
      {/* tabIndex -1 so the skip link can actually move focus here, not just
          scroll to it. */}
      <main id="main" tabIndex={-1}>
        {children}
      </main>
      <Footer />
    </div>
  );
}
